/* eslint-disable tsdoc/syntax */
import { useRouteLoaderData } from 'react-router';
import type { loader as cartLayoutLoader } from '../routes/_cart';

/**
 * Returns the `_cart` layout data
 *
 * @returns \{cart\} --
 * `cart` can either be an `Object` containing cart info, be `null` or `undefined`
 * If `cart` is null the customer is not registered or there were issues finding the customer data or setting the buyer identity
 * If `cart` is `undefined` the customer is suspended
 */
export const useCartLayoutData = () => {
  const cartLayoutData = useRouteLoaderData<typeof cartLayoutLoader>('routes/_cart');
  if (!cartLayoutData) {
    throw new Error('Unable to retrieve cart layout loader data');
  }
  return cartLayoutData;
};
